import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@common/components/modal';
import { Button } from '@common/components/Button';
import { FormControl } from '@common/components/form-control';
import { isEmail } from '@common/utils/email';

const requiredMark = <span style={{color: 'red', marginLeft: '2px'}}>*</span>;

export class NewUserWnd extends Component {
    state = {
        emailEdited: false,
    };

    handleChange = (e) => {
        this.props.onUserDataChanged(e.target.dataset.field, e.target.value);
    };

    handleUsernameBlur = (e) => {
        this.props.onUserDataChanged(e.target.dataset.field, e.target.value.trim());
    };

    handleEmailBlur = (e) => {
        this.setState({ emailEdited: true });
        this.props.onUserDataChanged('email', e.target.value.trim());
    };

    get emailError() {
        if (!this.state.emailEdited) return undefined;
        const I18n = require('react-redux-i18n').I18n;
        const email = this.props.email;
        if (!email || email.trim().length === 0) {
            return I18n.t('emailRequired');
        }
        if (!isEmail(email.trim())) {
            return I18n.t('emailInvalid');
        }
        return undefined;
    }

    render () {
        const I18n = require('react-redux-i18n').I18n;
        var topLabel = I18n.t('Passwords must contain');

        return (
            <Modal style={{top: '25%'}} dialogClassName="bootstrap-modal-medium" bsClass="bootstrap modal" show={this.props.show} onHide={this.props.onHide} animation={false} backdrop="static">
                <ModalHeader closeButton onHide={this.props.onHide}>
                    <ModalTitle id="lbl-title" style={{color: '#008DCE', fontWeight: 'normal'}}>{I18n.t('New User')}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div>{topLabel}</div>
                    <div className="row" style={{marginTop: '20px'}}>
                        <div id="lbl-user-name" className="col-sm-4" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('User Name')}{requiredMark}</div>
                        <div className="col-sm-7">
                            <FormControl
                                id="tx-user-name"
                                className="form-control"
                                type="text"
                                data-field="username"
                                value={this.props.username || ''}
                                onChange={this.handleChange}
                                onBlur={this.handleUsernameBlur}
                            />
                        </div>
                    </div>
                    <div className="row" style={{marginTop: '5px'}}>
                        <div id="lbl-email" className="col-sm-4" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('Email')}{requiredMark}</div>
                        <div className="col-sm-7">
                            <FormControl
                                id="tx-email"
                                className="form-control"
                                type="email"
                                data-field="email"
                                value={this.props.email || ''}
                                onChange={this.handleChange}
                                onBlur={this.handleEmailBlur}
                                errorMessage={this.emailError}
                            />
                        </div>
                    </div>
                    <div className="row" style={{marginTop: '5px'}}>
                        <div id="lbl-password" className="col-sm-4" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('Password')}{requiredMark}</div>
                        <div className="col-sm-7">
                            <FormControl
                                id="tx-password"
                                data-field="password"
                                className="form-control"
                                type="password"
                                value={this.props.password || ''}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="row" style={{marginTop: '5px'}}>
                        <div id="lbl-retype-password" className="col-sm-4" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('Retype Password')}{requiredMark}</div>
                        <div className="col-sm-7">
                            <FormControl
                                id="tx-retype-password"
                                className="form-control"
                                type="password"
                                data-field="retypedPassword"
                                value={this.props.retypedPassword || ''}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button id="btn-cancel" key="no" style={{width: "100px"}} onClick={this.props.onHide}>{I18n.t('Cancel')}</Button>
                    <Button id="btn-save" key="ok" type="submit" bsStyle="primary" style={{width: "100px"}} onClick={this.props.onSave}>{I18n.t('Save')}</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

NewUserWnd.propTypes = {
    show: PropTypes.bool.isRequired,
    error: PropTypes.string,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onUserDataChanged: PropTypes.func.isRequired,
    username: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
    retypedPassword: PropTypes.string
};
